define('areas/home/commands/showhelpcommand',["require", "exports", "services/settings", "common/string", "models/account"], function (require, exports, Configuration, StringExtensions, Account) {
    "use strict";
    var ShowHelpCommand = (function () {
        function ShowHelpCommand() {
        }
        ShowHelpCommand.prototype.execute = function (unit) {
            var isTenant = StringExtensions.contains(Account.Principal.current.memberType, "stb_");
            var url = Configuration.Settings.getUrlScheme() + (isTenant ? "://help.one-click.de/OneClickHelpAdvisor/en/Startseite" : "://help.one-Click.de/OneClickHelp/en/Startseite");
            window.open(url, "_blank");
        };
        return ShowHelpCommand;
    }());
    return ShowHelpCommand;
});

